import Model from '@/models/Model'

export default class HrMutual extends Model {
    resource() {
        return 'hr_mutual'
    }

    toCreate () {
      return this.clean([
        'branch_office_code',
        'quotation_rate',
        'hr_previred_mutual_id'
      ])
    }
}